export default __webpack_public_path__ + "static/Ramme-c3b2827f2b7cb2bd1724d8b9c741bb9e.svg";